import { FilterPage, FilterSort, Sample, SampleType, Status } from "@core/data";
import { SAMPLE_SORT_OPTIONS, SampleIndexQuery } from "../sample-index/sample-index.state-model";

export interface ImageMoveSamplePickerStateModel {
    orgKey: string;
    sampleType: SampleType;
    excludeSampleKey: string;

    status: Status;
    data: Sample[];
    total: number;

    page: FilterPage;
    sort: FilterSort;
    query: SampleIndexQuery;

    sortOptions: { id: string, label: string }[];
}

export const DEFAULTS: ImageMoveSamplePickerStateModel = {
    orgKey: null,
    sampleType: null,
    excludeSampleKey: null,
    status: Status.UNINITIALIZED,
    data: [],
    total: 0,
    page: {
        index: 0,
        size: 20
    },
    sort: {
        column: 'updatedAt',
        order: 'desc'
    },
    sortOptions: SAMPLE_SORT_OPTIONS,
    query: {
        search: null,
        rootstockCultivars: [],
        scionCultivars: [],
        sites: [],
        birthYear: [],
        birthWeek: [],
        scionCropId: [],
        scionLicensee: [],
        groupKey: [],
        rowIndex: null,
        positionIndex: null,
        hideDestroyed: true,
        excludeYear: false,
        startEvalPeriod: null,
        endEvalPeriod: null,
    },
};
